export const jsCodes: string[] = [
  'ad.adriver.ru/cgi-bin/json.cgi',
  'bs.serving-sys.ru',
  'eye.targetads.io',
] as const;
